<template>
  <b-row>
    <b-col cols="12">
      <b-card title="Listagem de Negociações (Novação)">
        <div class="custom-search d-flex justify-content-between mb-2">
          <b-button
            v-if="verificarPermissao('ROLE_PARCELAMENTO_INSERIR')"
            variant="primary"
            @click="addNew()"
          >
            Nova Negociação
          </b-button>

          <b-form-group class="mb-0">
            <div class="d-flex align-items-center">
              <label class="mr-1">Busca</label>
              <b-form-input
                v-model="searchTerm"
                placeholder="Pesquisar..."
                type="text"
                class="d-inline-block"
                @input="handleSearch"
              />
            </div>
          </b-form-group>
        </div>

        <vue-good-table
          mode="remote"
          :columns="columns"
          :rows="listaNegociacoes"
          :rtl="direction"
          :search-options="{ enabled: true, externalQuery: searchTerm }"
          :pagination-options="{ enabled: true, perPage: pageLength }"
          :total-rows="totalRecords"
          :is-loading.sync="isLoading"
          @on-sort-change="onSortChange"
        >
          <template
            slot="table-row"
            slot-scope="props"
          >
            <span v-if="props.column.field === 'action'">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle"
                  />
                </template>
                <b-dropdown-item @click="view(props.row)">
                  <feather-icon
                    icon="EyeIcon"
                    class="mr-50"
                  />
                  <span>Visualizar</span>
                </b-dropdown-item>
                <!-- Omitindo Delete/Edit para preservar integridade de novações consolidadas -->
              </b-dropdown>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import {
  BRow, BCol, BCard, BButton, BFormGroup, BFormInput, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import mixinsGlobal from '@/mixins'
import _ from 'lodash'

export default {
  name: 'NegociacaoGrid',
  components: {
    BRow, BCol, BCard, BButton, BFormGroup, BFormInput, BDropdown, BDropdownItem, VueGoodTable,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      listaNegociacoes: [],
      isLoading: false,
      totalRecords: 0,
      searchTerm: '',
      pageLength: 10,
      pageConfig: {
        page: 0,
        size: 10,
        sort: 'dataLancamento',
        order: 'desc',
      },
      columns: [
        { label: 'Número', field: 'numero' },
        { label: 'Data', field: 'dataLancamento', formatFn: this.formatDateGrid },
        { label: 'Associado', field: 'registro.nome' },
        { label: 'Descrição', field: 'descricao' },
        { label: 'Valor Total', field: 'valorTotal', formatFn: this.formatCurrencyBrazil },
        { label: 'Ações', field: 'action', sortable: false },
      ],
    }
  },
  computed: {
    direction() {
      return this.$store.state.appConfig.isRTL
    },
  },
  async mounted() {
    this.loadTable()
  },
  methods: {
    handleSearch: _.debounce(function () {
      this.pageConfig.page = 0
      this.loadTable()
    }, 300),
    onSortChange(params) {
      this.pageConfig.sort = params[0].field
      this.pageConfig.order = params[0].type
      this.loadTable()
    },
    async loadTable() {
      this.isLoading = true
      try {
        const payload = {
          filter: {
            renegociacao: true,
            campo: this.searchTerm,
          },
          pageConfig: this.pageConfig,
        }
        const result = await this.$store.dispatch('parcelamentoFinananceiroModule/filterPayment', payload)
        this.listaNegociacoes = result.data.content
        this.totalRecords = result.data.totalElements
      } catch (e) {
        console.error('Erro ao carregar negociações', e)
      } finally {
        this.isLoading = false
      }
    },
    addNew() {
      this.$emit('toggleForm', true)
    },
    view(data) {
      this.$emit('toggleForm', true, data.id)
    },
  },
}
</script>
